module.exports = __webpack_public_path__ + "img/faridah-bk-ymd.0f4caa17.png";